import { css } from 'lit';
export const tokenItemBaseHostStyle = css `
  :host {
    display: block;
    margin-top: 2px;
    width: 100%;
  }
`;
//# sourceMappingURL=token-item-base-host.style.js.map